
import { useProductModal } from '../../../context/ProductModalContext';
import { useCart } from '../../../context/CartContext';

export default function ProductCard({ id, name, price, originalPrice, image, badges = [], description  }) {
  const { openProductModal } = useProductModal();
  const { addToCart } = useCart();

  const getBadgeStyle = (badge) => {
    switch (badge) {
      case 'Best Seller':
        return 'bg-[#EF579A] text-white';
      case 'Low Stock':
        return 'bg-amber-500 text-white';
      case 'New Arrival':
        return 'bg-teal-500 text-white';
      case 'Hot':
        return 'bg-rose-500 text-white';
      case 'Sold Out':
        return 'bg-gray-500 text-white';
      default:
        return 'bg-gray-500 text-white';
    }
  };

  const discount = originalPrice ? Math.round(((originalPrice - price) / originalPrice) * 100) : 0;

  const handleCardClick = () => {
    openProductModal({ id, name, price, originalPrice, image, badges, description });
  };

  const handleQuickAdd = (e) => {
    e.stopPropagation();
    addToCart({ id, name, price, originalPrice, image, size: 'M' });
  };

  return (
    <div className="cursor-pointer group" data-product-shop onClick={handleCardClick}>
      <div className="relative aspect-[4/5] bg-[#faf8f8] rounded-xl overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {badges.length > 0 && (
          <div className="absolute top-3 left-3 z-[5] flex flex-col gap-1.5">
            {badges.map((badge, index) => (
              <div
                key={index}
                className={`${getBadgeStyle(badge)} rounded-full py-1 px-3 flex items-center justify-center`}
              >
                <p className="text-[10px] font-['Poppins'] font-semibold uppercase tracking-wide">{badge}</p>
              </div>
            ))}
          </div>
        )}
        {discount > 0 && (
          <div className="absolute top-3 right-3 bg-[#EF579A] text-white rounded-full py-1 px-2.5">
            <p className="text-[10px] font-['Poppins'] font-bold">-{discount}%</p>
          </div>
        )}
        <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <button 
            onClick={handleQuickAdd}
            className="w-full py-2.5 bg-white/95 backdrop-blur-sm text-gray-800 rounded-full font-['Poppins'] text-xs font-medium hover:bg-[#EF579A] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
          >
            Quick Add
          </button>
        </div>
        <button 
          onClick={(e) => e.stopPropagation()}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#EF579A] hover:text-white cursor-pointer"
        >
          <i className="ri-heart-line text-sm"></i>
        </button>
      </div>
      <div className="flex flex-col gap-1.5 mt-3 px-1">
        <p className="font-['Poppins'] font-medium text-sm text-gray-800 truncate">{name}</p>
        <div className="flex items-center gap-2">
          <p className="font-['Poppins'] font-bold text-base text-[#EF579A]">₦{price.toLocaleString()}</p>
          {originalPrice && (
            <p className="font-['Poppins'] text-xs text-gray-400 line-through">₦{originalPrice.toLocaleString()}</p>
          )}
        </div>
      </div>
    </div>
  );
}
